/**
 * Registering this browser as a push destination.
 *
 * One endpoint, POST-only. The backend stores `(token, platform)` against the signed-in consumer
 * and moves the row if the same token turns up under a different account — which is exactly what
 * happens when two people share a device, so the second sign-in must always re-register rather
 * than assume the token is already attached to the right person.
 */
import { apiRequest } from '@/shared/api/client';

export interface RegisterDeviceTokenResponse {
  /** False when the token was already on file for this account and nothing changed. */
  registered: boolean;
}

/** `platform` is a free-form string the backend caps at 32 characters; the apps send ios/android. */
export const WEB_PLATFORM = 'web';

export function registerDeviceToken(
  token: string,
  platform: string = WEB_PLATFORM,
): Promise<RegisterDeviceTokenResponse> {
  return apiRequest<RegisterDeviceTokenResponse>('/v1/consumer/device-tokens', {
    method: 'POST',
    body: { token, platform },
  });
}
